import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SpBuilderBoardTypeDto } from './sp-builder-board-type.dto';
import { SpBuilderBoardTypeCreatableInterface } from '../interfaces/sp-builder-board-type-creatable.interface';

export class SpBuilderBoardTypeCreateDto
  extends IntersectionType(
    PickType(SpBuilderBoardTypeDto, [
      'boardTypeId',
      'builderId',
      'itemDescription',
    ]),
    PartialType(PickType(SpBuilderBoardTypeDto, ['active'])),
  )
  implements SpBuilderBoardTypeCreatableInterface {}
